import { Record } from "immutable";

export const FindResult = Record({
  type: "",
  id: null,
  name: "",
  short_location: "",
  country_code: "",
  distance: 0,
  elevation_gain: 0,
  elevation_loss: 0,
  has_course_points: false,
  user_id: null,
  user_name: "",
});

export const deserializeFindResult = (routeResult) => {
  const result = {
    type: routeResult.type,
    user_name: routeResult.user_name,
  };

  if (result.type === "route") {
    return new FindResult(Object.assign(result, routeResult.route));
  } else if (result.type === "trip") {
    return new FindResult(Object.assign(result, routeResult.trip));
  }
};
